import { Link } from "react-router-dom"

const FooterUs = (props) => {

    const { isMobile } = props

    return (

        <article className={isMobile ? "" : "w50 separator-right"}>

            <h2 className="footer-title">Nosotros</h2>
            <p className="footer-text-strong"><strong>Séneca coordina las tecnologías de Audio, Video, Software y Equipos de Control para hacer que las necesidades de usuarios, medios de comunicación, publicaciones y cualquier servicio parlamentario esté cubierto con total garantía.</strong></p>
            <p className="footer-text">La experiencia adquirida en "Tecnología de Congresos" durante años nos ha permitido abordar proyectos innovadores en las Instituciones Parlamentarias en España y América Latina, trasladar esta experiencia a Diputaciones y Ayuntamientos, y también a grandes empresas.</p>
            <Link to="/conocenos" className="flex jcenter pad-20">
                <i className="bi bi-plus main-section-icon"></i>
            </Link>
            <label className="small-text-label">Proxecto cofinanciado por Igape, Xunta de Galicia e Fondo Europeo de Desenvolvemento Rexional do programa operativo 2014-2020</label>
            <img loading="lazy" alt="Imagen" className={isMobile ? "flex mauto w100" : "flex mauto"} src="/images/footer-us.jpg"></img>
        </article>
    )
}

export default FooterUs